import clsx from 'clsx';
import { type ForwardedRef, type MouseEvent, type PropsWithChildren, forwardRef } from 'react';
import type { Color } from './colors';
import type { FontSize, FontWeight } from './typography';
import { isDefined } from '@/utils/assertions';

/**
 * @example
 * <Text size="sm" icon="home" size="14" weight="bold" underline />
 */

export interface TextProps {
  color?: Color;
  size?: FontSize;
  weight?: FontWeight;
  underline?: boolean;
  strikethrough?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
}

export const Text = forwardRef(
  (props: PropsWithChildren<TextProps>, ref: ForwardedRef<HTMLSpanElement>) => {
    const {
      color,
      size,
      weight,
      underline: isUnderline = false,
      strikethrough: isStrikethrough = false,
      className,
      onClick,
      children,
    } = props;

    const componentClassName = clsx(
      [
        isDefined(size) && `fs-${size}`,
        isDefined(weight) && `fw-${weight}`,
        isDefined(color) && `text-${color}`,
        className,
      ],
      {
        'text-underline': isUnderline,
        'text-strikethrough': isStrikethrough,
      },
    );

    return (
      <span ref={ref} onClick={onClick} className={componentClassName}>
        {children}
      </span>
    );
  },
);
